// height in pixels
export enum PANEL_HEIGHT {
  XS = 100, // For embeddedMini tooltip panels
  S = 180,
  M = 220,
  L = 260,
  XL = 280,
}
